import { styled } from '@mui/material';

export const PartnerListLogo = styled('img')(() => ({
  width: '80px'
}));
